import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Home from '@material-ui/icons/HomeOutlined';
import ShoppingBasket from '@material-ui/icons/ShoppingBasketOutlined';
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';
import PersonOutline from '@material-ui/icons/PersonOutline';
import Mail from '@material-ui/icons/MailOutline';
import Photo from '@material-ui/icons/PhotoOutlined';
import CircularProgress from '@material-ui/core/CircularProgress';
import ExitToApp from '@material-ui/icons/ExitToApp';
import MenuIcon from '@material-ui/icons/Menu';
import { withStyles, withTheme } from '@material-ui/core';
import classes from './menu.module.scss';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import { Link, navigate } from '@reach/router';
import { Query, ApolloConsumer } from 'react-apollo';
import { GET_GREETING_INFO, GET_CHATS } from '../../queries';

const Greeting = () => (
  <div className={classes.greeting}>
    <Query query={GET_GREETING_INFO}>
      {({ loading, error, data }) => {
        if (loading) return <CircularProgress />;
        if (error) return <div>Error</div>;
        if (!data.me) {
          localStorage.removeItem('token');
        }
        return (
          data.me && (
            <>
              <img src={data.me.image || '/assets/profile_default.png'} />
              <div className={classes.greeting_text}>
                Привіт, {data.me.firstName}
              </div>
            </>
          )
        );
      }}
    </Query>
  </div>
);

function Menu() {
  const [isMenuShown, showMenu] = React.useState(false);

  const navigateToAddProduct = () => {
    navigate('/add-product');
  };

  const navigateToMailbox = () => {
    navigate('/mailbox');
  };

  const navigateToManageProducts = () => {
    navigate('/manage-products');
  };

  const navigateToFavorites = () => {
    navigate('/favorites');
  };

  const navigateToUserProfile = () => {
    navigate('/user-profile');
  };

  const sideList = (
    <div className={classes.list}>
      <div
        className={classes.header_menu}
        style={{ backgroundImage: 'url(/assets/menu_background.png)' }}
      >
        {localStorage.getItem('token') ? (
          <Greeting />
        ) : (
          <h3>
            <Link to="/login" style={{ textDecoration: 'none' }}>
              Вхід
            </Link>
            |
            <Link to="/signup" style={{ textDecoration: 'none' }}>
              Реєстрація
            </Link>
          </h3>
        )}
      </div>
      <List>
        <ListItem button onClick={() => navigate('/')}>
          <ListItemIcon>
            <Home />
          </ListItemIcon>
          <ListItemText primary={'Головна'} />
        </ListItem>
        {localStorage.getItem('token') ? (
          <ListItem button onClick={navigateToManageProducts}>
            <ListItemIcon>
              <ShoppingBasket />
            </ListItemIcon>
            <ListItemText primary={'Мої пропозиції'} />
          </ListItem>
        ) : null}
        <ListItem button onClick={navigateToFavorites}>
          <ListItemIcon>
            <FavoriteBorder />
          </ListItemIcon>
          <ListItemText primary={'Улюблені'} />
        </ListItem>
        {localStorage.getItem('token') ? (
          <ListItem button onClick={navigateToUserProfile}>
            <ListItemIcon>
              <PersonOutline />
            </ListItemIcon>
            <ListItemText primary={'Мій аккаунт'} />
          </ListItem>
        ) : null}
        {localStorage.getItem('token') ? (
          <ListItem button onClick={navigateToMailbox}>
            <ListItemIcon>
              <Query query={GET_CHATS}>
                {({ loading, error, data }) => {
                  if (loading || error) return null;

                  const unread = data.userChats.reduce(
                    (total, chat) => total + chat.unread,
                    0
                  );

                  return (
                    <Badge badgeContent={unread} max={99} color="primary">
                      <Mail />
                    </Badge>
                  );
                }}
              </Query>
            </ListItemIcon>
            <ListItemText primary={'Повідомлення'} />
          </ListItem>
        ) : null}
        {localStorage.getItem('token') ? (
          <ListItem button onClick={navigateToAddProduct}>
            <ListItemIcon>
              <Photo />
            </ListItemIcon>
            <ListItemText primary={'Додати пропозицію'} />
          </ListItem>
        ) : null}
        {localStorage.getItem('token') ? (
          <ApolloConsumer>
            {client => (
              <ListItem
                button
                onClick={() => {
                  localStorage.clear();
                  navigate(window.location.pathname);
                  client.resetStore();
                }}
              >
                <ListItemIcon>
                  <ExitToApp />
                </ListItemIcon>
                <ListItemText primary={'Вийти'} />
              </ListItem>
            )}
          </ApolloConsumer>
        ) : null}
      </List>
      <Divider />
      <List>
        {[
          'Допомога та інформація',
          'Партнерство',
          'Правила і умови',
          'Про Pastry'
        ].map(text => (
          <ListItem button key={text}>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <div>
      <IconButton className={classes.menuButton} onClick={() => showMenu(true)}>
        <MenuIcon className={classes.headerIcon} />
      </IconButton>
      <Drawer open={isMenuShown} onClose={() => showMenu(false)}>
        <div
          className={classes.list}
          tabIndex={0}
          role="button"
          onClick={() => showMenu(false)}
        >
          {sideList}
        </div>
      </Drawer>
    </div>
  );
}
export default withTheme()(withStyles(classes as any)(Menu));
